import React from 'react'

interface ChangeModelIconProps {
  size?: number
  color?: string
  className?: string
}

const ChangeModelIcon: React.FC<ChangeModelIconProps> = ({
  size = 32,
  color = 'white',
  className,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      className={className}
    >
      {/* 六边形外框 */}
      <path
        d="M8.0459 16.7715C7.76112 16.2966 7.76112 15.7034 8.0459 15.2285L11.3457 9.72852C11.6168 9.27671 12.1059 9 12.6328 9H19.3672C19.8941 9 20.3832 9.27671 20.6543 9.72852L23.9541 15.2285C24.2389 15.7034 24.2389 16.2966 23.9541 16.7715L20.6543 22.2715C20.3832 22.7233 19.8941 23 19.3672 23H12.6328C12.1059 23 11.6168 22.7233 11.3457 22.2715L8.0459 16.7715Z"
        stroke={color}
        strokeLinecap="round"
        strokeWidth="1"
        fill="none"
      />
      {/* 下方水平线 */}
      <path
        d="M19.5 17.2637H12.5L14.5 19.2637"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
        fill="none"
      />
      {/* 上方水平线 */}
      <path
        d="M12.5 14.7363H19.5L17.5 12.7363"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
        fill="none"
      />
    </svg>
  )
}

export default ChangeModelIcon
